import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { FormikProvider, useFormik } from 'formik';
import keys from 'lodash/keys';

// Components.
import { Wizard } from './Wizard';

// Core
import { IUserProfile, IProfileCertifyingBoard, IProfileStateBoard, useAppDispatch } from 'core';
import { AnalyticsService } from 'services/AnalyticsService';

// Store
import { onCompleteWizard, updateUserProfile } from 'store/profile/actions';
import { userProfileSelector } from 'store/profile/selectors';

// Styles.
import styles from './index.module.scss';

export const ProfileOnBoarding = (): ReactElement => {
  const dispatch = useAppDispatch();
  const userProfile: IUserProfile = useSelector(userProfileSelector);

  const formik = useFormik<IUserProfile>({
    initialValues: {
      certifyingBoards: userProfile?.certifyingBoards || [{} as IProfileCertifyingBoard],
      npi: userProfile?.npi,
      specialtyIds: userProfile?.specialtyIds || [],
      stateBoards: userProfile?.stateBoards || [{} as IProfileStateBoard],
    },
    onSubmit: async (values: IUserProfile): Promise<void> => {
      const { certifyingBoards, specialtyIds, stateBoards } = values;
      const submitValues: IUserProfile = {
        certifyingBoards: keys(certifyingBoards)?.length ? certifyingBoards : undefined,
        specialtyIds,
        stateBoards: keys(stateBoards)?.length ? stateBoards : undefined,
      };

      // We only show the wizard of profile/home if the `hasCompletedWizard` is false. If it is false and the user
      // makes a submit, we call another endpoint to update that flag on the backend.
      try {
        await dispatch(updateUserProfile(submitValues));
        await dispatch(onCompleteWizard());
      } catch (error) {
        AnalyticsService.trackException(error);
      }
    },
  });

  return (
    <div className={styles['profile-onboarding']}>
      <FormikProvider value={formik}>
        <Wizard />
      </FormikProvider>
    </div>
  );
};
